import NativeMixer from "./NativeMixer.js";

import { getWavBytes } from '../../factories/AudioConvertor'
import { setAssetItem } from "../assetStore/index.js";

// pgw 03-apr-2025
// let doprint = true;
let doprint = false;


class AudioEngine {
  processorNode;
  webaudioManager;
  playing = false;
  audioReady = false;
  currentPositonPollingInterval = null;
  currentPosition = 0;
  peaks = {
    channels: []
  }

  constructor() {
    this.boot();
    this.sendPlayCommand = this.sendPlayCommand.bind(this);

	// pgw 31-mar-2025
	// Oops - this was missing !
    this.sendLoopCommand = this.sendLoopCommand.bind(this);

    this.sendRecordCommand = this.sendRecordCommand.bind(this);
    this.loadChannelBuffers = this.loadChannelBuffers.bind(this);
    this.onMessageProcessorAudioScope = this.onMessageProcessorAudioScope.bind(this);
    this.sendRequestCurrentEngineStateCommand = this.sendRequestCurrentEngineStateCommand.bind(this);
    this.sendMasterMuteCommand = this.sendMasterMuteCommand.bind(this);
    this.getChannelPeak = this.getChannelPeak.bind(this);
    window.ramUsage = '0 mb';
    this.stateInterval = null;
  }

  async boot() {
    // The context is created by initialize() after the application starts.
  }

  getChannelPeak(index) {
    if (this.peaks && this.peaks.channels.length) {
      // if (index === 9) console.log(this.peaks.channels[index]);
      return this.peaks.channels[index];
    } else {
      return 0;
    }
  }

  async initialize(offlineRenderingOptions = null) {
    await this.dispose();
    const Context = window.AudioContext || window.webkitAudioContext;
    const audioContext = offlineRenderingOptions
      ? new window.OfflineAudioContext({ numberOfChannels: 2,
          length: Math.ceil(offlineRenderingOptions.length * 44100), sampleRate: 44100 })
      : new Context();
    this.webaudioManager = { audioContext };
    this.stereoInputNode = audioContext.createGain();
    this.audioReady = true;
    try { if (navigator.audioSession) navigator.audioSession.type = 'playback'; } catch (_) {}
  }

  async dispose() {
    await this.destroyAudioWorklet();
    if (this.userInputStream) this.userInputStream.getTracks().forEach(track => track.stop());
    this.userInputStream = null;
    if (this.userInputStreamSourceNode) this.userInputStreamSourceNode.disconnect();
    this.userInputStreamSourceNode = null;
    if (this.stereoInputNode) this.stereoInputNode.disconnect();
    this.stereoInputNode = null;
    this.userGrantedInput = false;
    const context = this.webaudioManager?.audioContext;
    if (context && context.close && context.state !== 'closed') await context.close();
    this.webaudioManager = null;
    this.audioReady = false;
  }

  startCurrentEngineStatePolling() {
    clearInterval(this.stateInterval);
    if (this.processorNode) {
      this.stateInterval = setInterval(()=> {
        if (this.processorNode) {
          this.sendRequestCurrentEngineStateCommand();
        } else {
          clearInterval(this.stateInterval);
        }
      }, 30);
  }
  }


  async onMessageProcessorAudioScope(message) {
    // console.log(message);
    if (message.event === "channelBuffersLoaded") {
      this.startCurrentEngineStatePolling()
      if (this.loadMultipleBuffersCallback) this.loadMultipleBuffersCallback();
      // this.encodedBuffers = null;
    }
    if (message.event === "singleChannelBufferLoaded") {
      if (this.loadSingleBufferCallback) this.loadSingleBufferCallback();
    }
    if (message.event === "bufferRecorded") {
      // get WAV file bytes and audio params of your audio source
      const wavBytes = getWavBytes(message.data.buffer, {
        isFloat: true, // floating point or 16-bit integer
        numChannels: 2,
        sampleRate: message.data.sampleRate,
      });
      // console.log(wavBytes);
      const wav = new Blob([wavBytes], { type: "audio/wav" });

      // // create download link and append to Dom
      // const downloadLink = document.createElement("a");
      // downloadLink.href = URL.createObjectURL(wav);
      // downloadLink.innerText = "Download";
      // downloadLink.style.float = 'right';
      // downloadLink.setAttribute("download", "my-audio.wav"); // name file
      // document.getElementById("root").appendChild(downloadLink);


      // encode to mp3 and store in indexdb
      const arrayBufferWav = await wav.arrayBuffer()

      await setAssetItem(message.data.id, arrayBufferWav);

      // const mp3URL = await endodeArrayBufferToMp3( `user${message.data.index}.mp3`, wavBytes,);
      // console.log(mp3URL);
      // // create download link and append to Dom
      // const downloadLink = document.createElement("a");
      // downloadLink.href = mp3URL;
      // downloadLink.innerText = "Download";
      // downloadLink.style.float = 'right';
      // downloadLink.setAttribute("download", "my-audio.mp3"); // name file
      // document.getElementById("root").appendChild(downloadLink);
      await this.loadChannelEncodedBuffer(arrayBufferWav, message.data.index);

    }
    if (message.event === 'data-transfer-current-engine-state') {
      // console.log(message.value);
      this.currentPosition = message.value.currentPosition;
      this.peaks = message.value.peaks;
    }
    if (message.event === 'data-transfer-punch-in-point') {
      // console.log(message.value);
      
    }
    if (message.event === 'data-transfer-punch-out-point') {
      // console.log(message.value);
      // this.currentPosition = message.value;
    }
    if (message.event === 'error') {
      alert(message.message);
    }
  }

  sendRequestCurrentEngineStateCommand() {
    if (this.processorNode) {
      this.processorNode.sendMessageToAudioScope({
        type: "command",
        payload: {
          id: "requestCurrentEngineState",
        },
      }); 
    }
  }

  sendSeekCommand(value) {
    if (this.processorNode) this.processorNode.sendMessageToAudioScope({
      type: "command",
      payload: {
        id: "seek",
        value
      },
    });
  }


  sendRequestPunchInPointCommand() {
    if (this.processorNode) this.processorNode.sendMessageToAudioScope({
      type: "command",
      payload: {
        id: "setAndRequestPunchInPoint",
      },
    });
  }

  sendRequestPunchOutPointCommand() {
    if (this.processorNode) this.processorNode.sendMessageToAudioScope({
      type: "command",
      payload: {
        id: "setAndRequestPunchOutPoint",
      },
    });
  }

  sendPlayCommand(offlineContext = false) {
    if (!this.processorNode) return;
    this.playing = true;
    return this.processorNode.play(offlineContext).catch(error => {
      this.playing = false;
      this.onMessageProcessorAudioScope({ event: 'error', message: error.message });
      if (offlineContext) throw error;
    });
  }

  sendLoopCommand(startMs, endMs) {

	if (doprint) console.log("pgw sendLoopCommand startMs = ", startMs)
	if (doprint) console.log("pgw sendLoopCommand endMs = ", endMs)

	// pgw 26-jul-2024 check that this.webaudioManager.audioContext is defined before using it
	if (this && this.webaudioManager && this.webaudioManager.audioContext) {
		if (doprint) console.log("sendLoopCommand this.webaudioManager.audioContext defined ")
	}
	else {
		if (doprint) console.log("sendLoopCommand this.webaudioManager.audioContext NOT defined ")
		return
	}



	// pgw 03-mar-2025 - testing fix loop bug
	// return;

	/*
	if (!startMs && !endMs) {
		// this.isLooping = false;
		return;
	}
	*/

	if (this.webaudioManager && this.webaudioManager.audioContext) {
		if (!this.webaudioManager.audioContext.startRendering) {
        this.webaudioManager.audioContext.resume().catch(() => {});
      }
		if (this.processorNode) this.processorNode.sendMessageToAudioScope({
		  type: "command",
		  payload: {
			id: "setLoop",
			times: {
			  startMs,
			  endMs
			}
		  },
		});
		if (!startMs && !endMs) {
		  this.isLooping = false;
		} else {
		  this.isLooping = true;
		}
	}

  }

  sendPauseCommand() {
    if (this.processorNode) this.processorNode.sendMessageToAudioScope({
      type: "command",
      payload: {
        id: "pausePlayback",
      },
    });
    this.playing = false;
  }

  sendStopCommand() {
    if (this.processorNode) this.processorNode.sendMessageToAudioScope({
      type: "command",
      payload: {
        id: "stopPlayback",
      },
    });
    this.playing = false
  }

  sendStopRecordCommand() {
    if (this.processorNode) this.processorNode.sendMessageToAudioScope({
      type: "command",
      payload: {
        id: "stopRecording",
      },
    });
    this.recording = false;
    this.playing = false;
  }

  sendRecordCommand() {
    if (!this.processorNode) return;
    if (this.recording) return;
    const mixer = this.processorNode;
    const generation = mixer.generation;
    this.webaudioManager.audioContext.resume().then(() => {
      if (!this.recording || this.processorNode !== mixer || generation !== mixer.generation) return;
      return mixer.record();
    }).catch(error => {
      this.recording = false;
      this.onMessageProcessorAudioScope({ event: 'error', message: error.message });
    });
    this.recording = true;
  }

  sendMasterMuteCommand(value) {
    // console.log(this);
    if (this.processorNode) this.processorNode.sendMessageToAudioScope({
      type: "command",
      payload: {
        id: "setMasterMute",
        value
      },
    });
  }

  loadSamplerBuffer(buffer) {
    if (!this.webaudioManager.audioContext.startRendering) {
        this.webaudioManager.audioContext.resume().catch(() => {});
      }
    if (this.processorNode) this.processorNode.sendMessageToAudioScope({
      type: "command",
      payload: {
        id: "loadSamplerBuffer",
        buffer: buffer,
      },
    });
  }

  // Keep the application-facing method name; mixing now uses native audio nodes.
  async createAudioWorklet(channelCount, offline = false) {
    await this.destroyAudioWorklet();
    this.processorNode = new NativeMixer(this.webaudioManager.audioContext, channelCount,
      message => this.onMessageProcessorAudioScope(message), this.stereoInputNode);
  }

  async requestUserMicrophone() {
    if (!this.userGrantedInput) {
      this.userInputStream = await navigator.mediaDevices.getUserMedia({ audio: {
        echoCancellation: false, noiseSuppression: false, autoGainControl: false
      }, video: false });
      await this.processorNode.prepareRecorder();
      if (!this.userInputStream) throw Error('Could no access user microphone');
      
      this.userInputStreamSourceNode = this.webaudioManager.audioContext.createMediaStreamSource(this.userInputStream);
      this.userInputStreamSourceNode.connect(this.stereoInputNode);

      this.userGrantedInput = true;
    }
    
    return this.userGrantedInput;
  }

  async removeChannel(index) {
    if (this.processorNode) this.processorNode.sendMessageToAudioScope({
      type: "command",
      payload: {
        id: "removeChannel",
        index
      },
    });
    return true;
  }

  make_download(abuffer, total_samples) {
    var new_file = URL.createObjectURL(bufferToWave(abuffer, total_samples));
    var download_link = document.getElementById("download_link");
    download_link.href = new_file;
    var name = generateFileName();
    download_link.download = name;
  }

  async getAudioContextRender(fileName) {
    await this.sendPlayCommand(true);
    const renderedBuffer = await this.webaudioManager.audioContext.startRendering();
      // console.log('Rendering completed successfully', renderedBuffer);

      const downloadLink = document.createElement("a");
      var renderUrl = URL.createObjectURL(bufferToWave(renderedBuffer, renderedBuffer.length));

      var name = generateFileName();
      downloadLink.href = renderUrl;
      downloadLink.download = name;
      downloadLink.style.display = 'none';
      downloadLink.setAttribute("download", `${fileName}.wav`); // name file
      document.getElementById("root").appendChild(downloadLink);
      downloadLink.click();
  }

  async destroyAudioWorklet() {
    clearInterval(this.stateInterval);
    this.stateInterval = null;
    if (this.processorNode) this.processorNode.disconnect();
    this.processorNode = null;
    this.playing = false;
    this.currentPosition = 0;
    this.peaks = { channels: [], master: 0 };
  }

  destructProcessorMixerEngine(newChannelCount) {
    if (this.processorNode) this.processorNode.reset(newChannelCount);
    this.playing = false;
    this.currentPosition = 0;
  }

  async loadChannelBuffers(buffers) {
    if (!this.processorNode) throw new Error('Audio engine is not initialized');
    this.processorNode.loadBuffers(buffers);
    this.startCurrentEngineStatePolling();
  }

  async loadChannelEncodedBuffer(encodedBuffer, index) {
    if (!this.processorNode) throw new Error('Audio engine is not initialized');
    await this.processorNode.loadEncodedBuffer(encodedBuffer, index);
  }

  async loadChannelEncodedBuffers(encodedBuffers) {
    if (!this.processorNode) throw new Error('Audio engine is not initialized');
    const mixer = this.processorNode;
    for (let index = 0; index < encodedBuffers.length; index++) {
      try {
        await mixer.loadEncodedBuffer(encodedBuffers[index], index);
        if (this.processorNode !== mixer) throw new Error("Audio loading was cancelled");
      } catch (error) {
        throw new Error(`Could not decode stem ${index + 1}: ${error.message}`);
      }
    }
    mixer.updateMemoryUsage();
    this.startCurrentEngineStatePolling();
  }

  loadAssets(assets) {
    if (this.processorNode) this.processorNode.sendMessageToAudioScope({
      type: "command",
      payload: {
        id: "loadPlayerAssets",
        assets: assets,
      },
    });
  }

  addInputChannel(name, duration, channelId) {

	// pgw 30-mar-2026 testing
	// console.log("addInputChannel p1 name = ", name);
	// console.log("addInputChannel p1 duration = ", duration);


    if (!this.webaudioManager.audioContext.startRendering) {
        this.webaudioManager.audioContext.resume().catch(() => {});
      }
    if (this.processorNode) this.processorNode.sendMessageToAudioScope({
      type: "command",
      payload: {
        id: "addNewChannel",
        name,
        duration,
        channelId: channelId
      },
    });
  }

  sendChannelParamChange(channelIndex, paramName, value) {
    // console.log(channelIndex, paramName, value);
    if (this.processorNode) this.processorNode.sendMessageToAudioScope({
      type: "parameterChange",
      data: {
        scope: "channel",
        paramName: paramName,
        channelIndex: channelIndex,
        value: value,
      },
    });
  }

  sendGlobalParamChange(paramName, value) {
    if (!this.processorNode) return Promise.resolve();
    return this.processorNode.setEffects(paramName, value).catch(error => {
      this.playing = false;
      this.onMessageProcessorAudioScope({ event: 'error', message: error.message });
      throw error;
    });
  }

}

function generateFileName() {
  var origin_name = 'offlineRender.wav';
  var pos = origin_name.lastIndexOf('.');
  var no_ext = origin_name.slice(0, pos);

  return no_ext + ".wav";
}

// Convert an AudioBuffer to a Blob using WAVE representation
function bufferToWave(abuffer, len) {
  var numOfChan = abuffer.numberOfChannels,
      length = len * numOfChan * 2 + 44,
      buffer = new ArrayBuffer(length),
      view = new DataView(buffer),
      channels = [], i, sample,
      offset = 0,
      pos = 0;

  // write WAVE header
  setUint32(0x46464952);                         // "RIFF"
  setUint32(length - 8);                         // file length - 8
  setUint32(0x45564157);                         // "WAVE"

  setUint32(0x20746d66);                         // "fmt " chunk
  setUint32(16);                                 // length = 16
  setUint16(1);                                  // PCM (uncompressed)
  setUint16(numOfChan);
  setUint32(abuffer.sampleRate);
  setUint32(abuffer.sampleRate * 2 * numOfChan); // avg. bytes/sec
  setUint16(numOfChan * 2);                      // block-align
  setUint16(16);                                 // 16-bit (hardcoded in this demo)

  setUint32(0x61746164);                         // "data" - chunk
  setUint32(length - pos - 4);                   // chunk length

  // write interleaved data
  for(i = 0; i < abuffer.numberOfChannels; i++)
    channels.push(abuffer.getChannelData(i));

  while(pos < length) {
    for(i = 0; i < numOfChan; i++) {             // interleave channels
      sample = Math.max(-1, Math.min(1, channels[i][offset])); // clamp
      sample = (0.5 + sample < 0 ? sample * 32768 : sample * 32767)|0; // scale to 16-bit signed int
      view.setInt16(pos, sample, true);          // write 16-bit sample
      pos += 2;
    }
    offset++                                     // next source sample
  }

  // create Blob
  return new Blob([buffer], {type: "audio/wav"});

  function setUint16(data) {
    view.setUint16(pos, data, true);
    pos += 2;
  }

  function setUint32(data) {
    view.setUint32(pos, data, true);
    pos += 4;
  }
}

export { AudioEngine };
export default AudioEngine;
